import robo from '../../images/robo.png';
import generation from '../../images/generation.png';

export const homeObjOne = {
  id: 'automation',
  lightBg: false,
  lightText: true,
  topLine: 'Automation',
  headline: 'Social Media',
  description:
    'In today\'s world social media is one of the important platforms for marketing and we excel at social media marketing. We provide services from shooting, to editing, to final execution of social media posts for your company so you can live stress-free about it.',
  buttonLabel: 'Scroll Top',
  imgStart: false,
  img: robo,
  alt: 'Social media',
  dark: true,
  primary: true,
  darkText: false,
  buttonLink: 'social-home',
};

export const homeObjTwo = {
  id: 'mediageneration',
  lightBg: true,
  lightText: false,
  topLine: 'Media Generation',
  headline: 'Content Generation',
  description:
    'We excel at producing creative ideas for content creation so that your posts get more attention and more views, so that your brand gets all the success needed to be at the forefront.',
  buttonLabel: 'Home',
  imgStart: true,
  img: generation,
  alt: 'Content generation',
  dark: false,
  primary: false,
  darkText: true,
  buttonLink: 'social-home',
};
